import React, { useEffect } from 'react'
import LeadsFilterData from './LeadsDataWithFilter'
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import leadConfig from '../../config/leadConfig';
import { useAuth } from '../../hooks/useAuth';
import * as OemHistoryAction from "../../redux/actions/oemHistoryAction";
import { savePreference, fetchPreferences, deletePreference } from "../../redux/slices/preferenceSlice";


function DefaultLeadsPage({ leadType }) {
  const dispatch = useDispatch();
  const { permissionsFlag, user } = useAuth();

  const [matchedPermission, setMatchedPermission] = React.useState(null);
  const config = leadConfig[leadType] || leadConfig["All"];
  const {
    getAllLeads = () => { },
    getleadDetails = () => { },
    getAllStatusFields = () => { },
    getFreshWorkFields = () => { },
    getDealersAndAreas = () => { },
    getPincodeDirectoryFields = () => { },
    getTenureDownpayRangeFields = () => { },
    uploadleads = () => { },
    getleadViewDetails = () => { },
    downloadLeads = () => { },
    getUniqueFields = () => { },
    getInboundUniqueFields = () => { },
    getBrandFields = () => { },
    getFilterDropdownOptions = () => { },
    getGoogleSignedRecordingUrl = () => { },
    uploadRetailLeads = () => { },
  } = bindActionCreators(
    config.actions,
    dispatch
  );

  const { fetchOEMHistory = () => { } } = bindActionCreators(OemHistoryAction, dispatch);

  useEffect(() => {
    const adminType = user?.type;
    if (permissionsFlag?.length > 0 || adminType === "SUPER") {
      const matched = {
        permission: permissionsFlag?.find(permission => permission.key === config?.permissionKey) || null,
        adminType: adminType,
      };
      setMatchedPermission(matched);
    }
  }, [permissionsFlag]);

  const { allLeadsData, loading } = useSelector(config.selector);
  const { columnsData, columnLoading, columnsError } = useSelector(config.columnSelector);

  return (
    <>
      <LeadsFilterData
        columnType={config.columnType}
        apiType={config.apiType}
        leadType={leadType}
        uploadtype={config.uploadtype}
        manualUploadtype={config.manualUploadtype}
        downloadType={config.downloadType}
        fetchColumns={config.fetchColumns}
        allLeadsData={allLeadsData}
        columnsData={columnsData}
        columnLoading={columnLoading}
        columnsError={columnsError}
        getAllLeads={getAllLeads}
        getleadViewDetails={getleadViewDetails}
        getleadDetails={getleadDetails}
        uploadleads={uploadleads}
        getAllStatusFields={getAllStatusFields}
        getFreshWorkFields={getFreshWorkFields}
        getPincodeDirectoryFields={getPincodeDirectoryFields}
        getTenureDownpayRangeFields={getTenureDownpayRangeFields}
        getFilterDropdownOptions={getFilterDropdownOptions}
        loading={loading}
        availableFilter={config.Filter}
        availableFilterValues={config.FilterData}
        downloadLeads={downloadLeads}
        matchedPermission={matchedPermission}
        savePreference={savePreference}
        fetchPreferences={fetchPreferences}
        deletePreference={deletePreference}
        getInboundUniqueFields={getInboundUniqueFields}
        getUniqueFields={getUniqueFields}
        fetchOEMHistory={fetchOEMHistory}
        getDealersAndAreas={getDealersAndAreas}
        getBrandFields={getBrandFields}
        getGoogleSignedRecordingUrl={getGoogleSignedRecordingUrl}
        uploadRetailLeads={uploadRetailLeads}
      />
    </>

  )
}

export default DefaultLeadsPage